iframeAdBlockerChecker = (iframe) => {
    if (!iframe) { console.warn('[iframe-check] No iframe found.'); return; }
    if (!iframe.id) iframe.id = 'provider-frame';

    const showHint = () => {
        if (!document.getElementById('survey-frame-hint')) {
            const d = document.createElement('div');
            d.id = 'survey-frame-hint';
            d.className = 'alert alert-warning border-warning border-1';
            d.innerHTML = `<i class="fa fa-warning me-2"></i>${
                window.IframeAdBlockerAlert ||
                'This job may not display or work correctly with an ad blocker enabled. Please disable it and reload the page to continue.'
            }`;
            iframe.insertAdjacentElement('afterend', d);
        }
    };

    const src = iframe.getAttribute('src') || iframe.dataset?.src;
    if (!src) { console.warn('[iframe-check] iframe has no src.'); return; }
    if (!iframe.getAttribute('src')) iframe.setAttribute('src', src);

    const TIMEOUT_MS = 15000;
    let ready = false;

    const allowedOrigin = (() => { try { return new URL(src, location.href).origin; } catch { return ''; } })();

    const markReady = () => {
        if (ready) return;
        ready = true;
        cleanup();
    };

    const onMessage = (e) => {
        if (allowedOrigin && e.origin !== allowedOrigin) return;
        if (e.data && e.data.type === 'FORM_READY') markReady();
    };
    window.addEventListener('message', onMessage);

    const namePoll = setInterval(() => {
        try {
            if (iframe.contentWindow && iframe.contentWindow.name === 'FORM_READY') markReady();
        } catch (_) {}
    }, 300);

    iframe.addEventListener('load', markReady, { once: true });

    const parent = iframe.parentNode || document.body;
    const removalObserver = new MutationObserver(() => {
        if (!document.body.contains(iframe) && !ready) showHint();
    });
    removalObserver.observe(parent, { childList: true });

    probeAdblock(src, 6000)
        .then((blocked) => { if (blocked && !ready) showHint(); })
        .catch(() => { /* ignore */ });

    const timeoutId = setTimeout(() => { if (!ready) showHint(); cleanup(true); }, TIMEOUT_MS);

    function cleanup(keepObserver = false) {
        clearTimeout(timeoutId);
        clearInterval(namePoll);
        window.removeEventListener('message', onMessage);
        iframe.removeEventListener('load', markReady);
        if (!keepObserver) removalObserver.disconnect();
    }
};


function probeAdblock(url, probeTimeoutMs = 5000) {
    return new Promise((resolve) => {
        let done = false;

        const timer = setTimeout(() => {
            if (done) return;
            done = true;
            resolve(true);
        }, probeTimeoutMs);

        fetch(url, { mode: 'no-cors', cache: 'no-store' })
            .then(() => {
                if (done) return;
                done = true;
                clearTimeout(timer);
                resolve(false);
            })
            .catch(() => {
                if (done) return;
                done = true;
                clearTimeout(timer);
                resolve(true);
            });
    });
}
iframeAdBlockerChecker = (iframe) => {
    if (!iframe) { console.warn('[iframe-check] No iframe found.'); return; }
    if (!iframe.id) iframe.id = 'provider-frame';

    const showHint = () => {
        if (!document.getElementById('survey-frame-hint')) {
            const d = document.createElement('div');
            d.id = 'survey-frame-hint';
            d.className = 'alert alert-warning border-warning border-1';
            d.innerHTML = `<i class="fa fa-warning me-2"></i>${
                window.IframeAdBlockerAlert ||
                'This job may not display or work correctly with an ad blocker enabled. Please disable it and reload the page to continue.'
            }`;
            iframe.insertAdjacentElement('afterend', d);
        }
    };

    const src = iframe.getAttribute('src') || iframe.dataset?.src;
    if (!src) { console.warn('[iframe-check] iframe has no src.'); return; }
    if (!iframe.getAttribute('src')) iframe.setAttribute('src', src);

    const TIMEOUT_MS = 15000;
    let ready = false;

    const allowedOrigin = (() => { try { return new URL(src, location.href).origin; } catch { return ''; } })();

    const markReady = () => {
        if (ready) return;
        ready = true;
        cleanup();
    };

    const onMessage = (e) => {
        if (allowedOrigin && e.origin !== allowedOrigin) return;
        if (e.data && e.data.type === 'FORM_READY') markReady();
    };
    window.addEventListener('message', onMessage);

    const namePoll = setInterval(() => {
        try {
            if (iframe.contentWindow && iframe.contentWindow.name === 'FORM_READY') markReady();
        } catch (_) {}
    }, 300);

    iframe.addEventListener('load', markReady, { once: true });

    const parent = iframe.parentNode || document.body;
    const removalObserver = new MutationObserver(() => {
        if (!document.body.contains(iframe) && !ready) showHint();
    });
    removalObserver.observe(parent, { childList: true });

    probeAdblock(src, 6000)
        .then((blocked) => { if (blocked && !ready) showHint(); })
        .catch(() => { /* ignore */ });

    const timeoutId = setTimeout(() => { if (!ready) showHint(); cleanup(true); }, TIMEOUT_MS);

    function cleanup(keepObserver = false) {
        clearTimeout(timeoutId);
        clearInterval(namePoll);
        window.removeEventListener('message', onMessage);
        iframe.removeEventListener('load', markReady);
        if (!keepObserver) removalObserver.disconnect();
    }
};


function probeAdblock(url, probeTimeoutMs = 5000) {
    return new Promise((resolve) => {
        let done = false;

        const timer = setTimeout(() => {
            if (done) return;
            done = true;
            resolve(true);
        }, probeTimeoutMs);

        fetch(url, { mode: 'no-cors', cache: 'no-store' })
            .then(() => {
                if (done) return;
                done = true;
                clearTimeout(timer);
                resolve(false);
            })
            .catch(() => {
                if (done) return;
                done = true;
                clearTimeout(timer);
                resolve(true);
            });
    });
}
